module.exports = __webpack_public_path__ + "img/f.5dd2651c.png";